import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import * as S from './styles';

import Header from '../../molecules/Header';
import NavBar from '../../molecules/NavBar';
import MainContent from '../../molecules/MainContent';
import Footer from '../../molecules/Footer';
import ProfileCardMenu from '../../organisms/ProfileCardMenu';
import TabsContainer from '../../molecules/TabsContainer';
import TransactionsTab from '../../organisms/TransactionsTab';
import { TransactionStatusTypes } from '../../../utils/constants';
import { fireAuth } from '../../../database/utils/firebase';
import { onClientTransactionItems } from '../../../database/repositories/TransactionItemRepository';
import { compareSort } from '../../../utils/util';

function UserPurchases() {
  const { tab } = useParams();
  const [currentTab, setCurrentTab] = useState(tab ?? 'abertas');
  const [items, setItems] = useState([]);
  const [sortedItems, setSortedItems] = useState([]);

  useEffect(() => {
    if (!fireAuth.currentUser?.uid) return;
    const subscribe = onClientTransactionItems(setItems);
    return () => subscribe();
  }, [fireAuth.currentUser]);

  useEffect(() => {
    if (tab) setCurrentTab(tab);
  }, [tab]);

  useEffect(() => {
    Promise.all(
      items
        ?.map(async (item) => {
          const transDoc = await item.transactionRef.get();
          const chargeUrl = transDoc.data()?.chargeUrl;
          return { ...item, chargeUrl };
        })
        ?.sort(
          compareSort(
            'status',
            currentTab === 'abertas'
              ? TransactionStatusTypes.Open
              : TransactionStatusTypes.Concluded
          )
        )
    ).then((res) => setSortedItems(res));
  }, [items, currentTab]);

  return (
    <S.Container>
      <Header />
      <NavBar />
      <MainContent>
        <S.UserBoughtContainer>
          <ProfileCardMenu />
          <TabsContainer
            icon_code="fas fa-shopping-basket"
            title="COMPRAS"
            tabs={[
              { title: 'EM ABERTO', url: '/usuario/compras/abertas' },
              { title: 'CONCLUÍDAS', url: '/usuario/compras/concluidas' }
            ]}>
            <TransactionsTab tabId="open_purchases" items={sortedItems} />
          </TabsContainer>
        </S.UserBoughtContainer>
      </MainContent>
      <Footer />
    </S.Container>
  );
}

export default UserPurchases;
